document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeRecommendHitTemplate', function(_defaultTemplate, html, item) {
        const _t = window.algoliaStrings || {};
        function translateUnit(u) {
          if (!u) return u;
          if (u === 'Each') return _t.unitEach || u;
          var setMatch = u.match(/^Set of (\d+)$/);
          if (setMatch) return (_t.unitSetOf || u).replace('{{number}}', setMatch[1]);
          var pkgMatch = u.match(/^Pkg\. of (\d+)$/);
          if (pkgMatch) return (_t.unitPkgOf || u).replace('{{number}}', pkgMatch[1]);
          return u;
        }
        const hit = item;
        const sku = hit.sku;
        const showInventory = hit.meta?.product?.cfp_inventory ? parseInt(hit.meta.product.cfp_inventory, 10) : null;
        const hasInventoryCount = typeof hit.variants_inventory_count === 'number';
        const getBadge = () => {
          let categoryBadge = hit.meta?.product?.cat_filter || '';

          if (categoryBadge === 'New Products') {
            categoryBadge = 'New';
          } else if (!['Sale', 'Used'].includes(categoryBadge)) {
            categoryBadge = '';
          } else if (hit.meta?.product?.sale_item_default_price && hit.price < hit.meta?.product?.sale_item_default_price && !mapPricingHit) {
            categoryBadge = 'Sale';
          } else if (categoryBadge === 'Clearance') {
            categoryBadge = 'Sale';
          }

          return categoryBadge;
        };
    
        const badge = getBadge();
        const badgeHandle = badge.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

        let buttonText;
        let requestQuote = false;
        const mapPricing = hit.meta?.product?.map_pricing;
        const mapPricingHit = mapPricing && hit.price < Number(mapPricing);
        let hasMultipleVariants = false;
        const availability = hit.meta?.product?.availability?.toLowerCase();
        const advancedProductListingsLink = hit.meta?.product?.advanced_plp_link;

        // Check for multiple variants
        if (hit.variants_count >= 2) {
            buttonText = _t.chooseOptions || 'Choose Options';
            hasMultipleVariants = true;
        } else if (availability === 'pre-order') {
            buttonText = _t.preorder || 'Preorder';
        } else if (availability === 'call for pricing') {
            buttonText = _t.requestQuote || 'Request a Quote';
            requestQuote = true;
        } else if (advancedProductListingsLink) {
            buttonText = _t.chooseOptions || 'Choose Options';
        } else {
            buttonText = (window.variantStrings && window.variantStrings.addToCart) || algoliaShopify.translations.addToCart;
        }

        return html`
          <div
            class="ais-hit ais-product product-card-wrapper twcss-shadow-solid twcss-rounded-2xl twcss-border-black twcss-p-2"
            data-algolia-index="${hit.index}"
            data-algolia-position="${hit.productPosition}"
            data-algolia-queryid="${hit.queryID}"
            data-algolia-objectid="${hit.objectID}"
            data-handle="${hit.handle}"
            data-variant-id="${hit.objectID}"
            data-distinct="${hit._distinct}"
            data-product-id="${hit.id}"
            onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
          >
            ${badge ? html`
              <div class="badge badge--${badgeHandle}">
                ${badge}
              </div>
            ` : ""}

            <a 
              class="card--hit-link" 
              href="${advancedProductListingsLink ? advancedProductListingsLink : algoliaShopify.helpers.instantsearchLink(hit)}" 
              onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}" 
              alt="${hit.title}"
            >
              <div class="card card--standard card--media" style="--ratio-percent: 100%;">
                <div class="card__inner color-scheme-1 gradient ratio twcss-shadow-reset" style="--ratio-percent: 100%;">
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      <a href="${advancedProductListingsLink ? advancedProductListingsLink : algoliaShopify.helpers.instantsearchLink(hit)}">
                        <img src="${algoliaShopify.helpers.mediumImage(hit)}" alt="${hit.title} - ${hit.variant_title}" />
                      </a>
                    </div>
                  </div>
                </div>

                <div class="card__content">
                  <div class="card__information">
                    <h3 class="ais-hit--title card__heading h6">
                      <a 
                        class="full-unstyled-link" 
                        data-algolia-index="${hit.index}"
                        data-algolia-position="${hit.productPosition}" 
                        data-algolia-queryid="${hit.queryID}"
                        data-algolia-objectid="${hit.objectID}" 
                        href="${advancedProductListingsLink ? advancedProductListingsLink : algoliaShopify.helpers.instantsearchLink(hit)}"
                        title="${algoliaShopify.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}"
                      >
                        ${hit.title}
                      </a>
                    </h3>

                    <div class="ais-hit--info">
                      ${hit.sku && html`
                        <span class="algolia-sku"><strong>${_t.sku || 'SKU:'}</strong> <span>${hit.sku}</span></span>
                      `}
                    </div>

                    ${!advancedProductListingsLink ? html`
                      <div class="inventory-wrapper">
                        ${hit.meta?.product?.non_stock_status ? html`
                          <p class="non-stock-status">${hit.meta?.product?.non_stock_status}</p>
                        ` : hit.variants_inventory_count > 0 ? html`
                          <p class="in-stock">
                            <span class="twcss-text-green">${_t.inStock || 'In stock,'}</span> (
                            ${hit.variants_inventory_count >= 99 ? html`
                              <span class="twcss-text-green high-stock">${_t.highStock || '99+ Available'}</span>
                            ` : hit.variants_inventory_count > 5 ? html`
                              <span class="twcss-text-green has-stock">${hit.variants_inventory_count} ${_t.available || 'Available'}</span>
                            ` : hit.variants_inventory_count >= 1 ? html`
                              <span class="twcss-text-red low-stock">${hit.variants_inventory_count} ${_t.lowStockSuffix || 'left!'}</span>
                            ` : ''}
                            )
                          </p>
                        ` : showInventory > 0 ? html`
                      <p class="in-stock">
                        <span class="twcss-inline-block twcss-text-green twcss-text-base">${_t.inStock || 'In stock,'}</span>
                          ${showInventory >= 99 ? html`<span class="twcss-text-green high-stock"> ${_t.highStock || '99+ Available'}</span>` :
                              showInventory > 5 ? html`<span class="twcss-text-green has-stock"> ${showInventory} ${_t.available || 'Available'}</span>` :
                                showInventory >= 1 ? html`<span class="twcss-text-red low-stock"> ${showInventory} ${_t.lowStockSuffix || 'left!'}</span>` :
                                  html`<span> ${hasInventoryCount && hit.inventory_available ? (_t.onBackorder || 'Available on Backorder') : ''}</span>`}
                      </p>
                  ` : html`
                      <p class="not-tracked">${hasInventoryCount && hit.inventory_available ? (_t.onBackorder || 'Available on Backorder') : ''}</p>
                  `}
              </div>
                    ` : ''}

                    ${advancedProductListingsLink ? html`
                      <p class="ais-hit--price">
                        <strong>${_t.priceVaries || 'Price varies'}</strong>
                      </p>
                    ` : html`
                      ${availability !== 'call for pricing' ? html`
                      <p class="ais-hit--price ${requestQuote || mapPricingHit ? 'twcss-hidden' : ''}" >
                          ${algoliaShopify.helpers.displayPrice(hit, hit._distinct)} 
                        ${hit.meta?.product?.unit_of_measure?.toLowerCase() != '' && hit.meta?.product?.unit_of_measure != null &&  html `
                          <span class="unit">/ ${translateUnit(hit.meta?.product?.unit_of_measure)}</span>
                        `}
                        <span class="ais-hit--price-discount-wrapper">
                        ${html`
                          <span class="ais-hit--price-striked">
                            <span>
                              ${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}
                            </span>
                          </span>
                        `}
                        ${html`
                          <span class="ais-hit--price-discount">
                            ${algoliaShopify.helpers.displayDiscount(
                            hit.price,
                            hit.compare_at_price,
                            hit.price_ratio
                          ).replace('-', '')}
                          </span>
                        `}
                          </span>
                      </p>`: html`<p class="ais-hit--price">${_t.requestQuote || 'Request a Quote'}</p>`}
                    `}

                    ${hit.meta?.product?.sale_item_default_price && hit.price < hit.meta?.product?.sale_item_default_price ? html`
                      <p class="ais-hit--price-discount-wrapper">
                        <span class="ais-hit--price-striked">
                            ${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.meta?.product?.sale_item_default_price)}

                            <span class="ais-hit--sale-percentage">${Math.round(((hit.meta?.product?.sale_item_default_price - hit.price) / hit.meta?.product?.sale_item_default_price) * 100)}${_t.percentOff || '% off'}</span>
                        </span>
                      </p>
                      ` : ''}
                  </div>
                </div>
              </div>
            </a>

            ${!requestQuote && !hasMultipleVariants && !advancedProductListingsLink ? html`
              <form 
                id="algolia-add-to-cart-${hit.objectID}" 
                action="/cart/add" 
                method="post"
                enctype="multipart/form-data" 
                class="mobile-form"
              >
                <div class="form-wrapper" style="display: flex; align-items: center; gap: 8px;">
                  <input 
                    type="number" 
                    name="quantity" 
                    value="1" 
                    min="1"
                    class="quantity-input qty"
                    style="width: 60px; height: 35px; padding: 0 8px; border: 1px solid #ddd; border-radius: 4px;"
                  />
                  <input type="hidden" name="id" value="${hit.objectID}" />
                  <button class="ais-hit--cart-button quick-add__submit button button--full-width button--secondary twcss-inline twcss-bg-accentBlue twcss-min-h-[1rem] twcss-all-w-reset twcss-min-w-40 twcss-text-white twcss-p-2 twcss-border-reset" data-form-id="algolia-add-to-cart-${hit.objectID}">
                    <span>${buttonText}</span>
                  </button>
                </div>
              </form>
            ` : hasMultipleVariants && !advancedProductListingsLink ? html`
              <a 
                href="${algoliaShopify.helpers.instantsearchLink(hit)}" 
                class="ais-hit--cart-button request-a-quote request-a-quote-mobile"
              >
                <span>${buttonText}</span>
              </a>
            ` : advancedProductListingsLink ? html`
              <a 
                href="${advancedProductListingsLink}" 
                class="ais-hit--cart-button request-a-quote request-a-quote-mobile"
              >
                <span>${buttonText}</span>
              </a>
            ` : html`
              <a 
                href="${algoliaShopify.helpers.instantsearchLink(hit)}" 
                class="ais-hit--cart-button request-a-quote request-a-quote-mobile"
              >
                <span>${buttonText}</span>
              </a>
            `}
          </div>
        `;
    })
})